import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  
  static values = {
    preselected: String,
    url: String
  }

  connect() {
    this.initializeSelectize()
  }

  disconnect() {
    if (this.selectize) {
      this.selectize.destroy()
    }
  }

  initializeSelectize() {
    const element = this.hasInputTarget ? this.inputTarget : this.element
    const preselectedData = this.preselectedValue ? JSON.parse(this.preselectedValue) : []
    const searchUrl = this.urlValue || '/admin/items/search'

    $(element).selectize({
      plugins: ['remove_button'],
      valueField: 'id',
      labelField: 'name',
      searchField: ['name', 'item_number'],
      placeholder: element.placeholder,
      create: false,
      maxItems: null,
      preload: false,
      options: preselectedData,
      items: preselectedData.map(item => item.id),
      load: (query, callback) => {
        if (!query.length) return callback()
        
        $.ajax({
          url: searchUrl,
          type: 'GET',
          dataType: 'json',
          data: { q: query },
          error: () => {
            callback()
          },
          success: (data) => {
            callback(data)
          }
        })
      },
      render: {
        option: (item, escape) => {
          let html = `<div><strong>${escape(item.name)}</strong>`
          if (item.item_number) {
            html += `<br><small class="text-muted">Item #: ${escape(item.item_number)}</small>`
          }
          if (item.manufacturer_name) {
            html += `<br><small class="text-muted">${escape(item.manufacturer_name)}</small>`
          }
          html += '</div>'
          return html
        },
        item: (item, escape) => {
          return `<div>${escape(item.name)}</div>`
        }
      }
    })

    this.selectize = element.selectize
  }
}